import { NgModule } from '@angular/core';
import {
  FileUploaderComponent,
  FormFieldComponent,
  FormTextareaComponent,
} from '@pishgamrayan/ng-form-kit';

import { DatepickerComponent } from './datepicker/datepicker.component';
import { TimepickerComponent } from './timepicker/timepicker.component';
import { ToggleSwitchComponent } from './toggle-switch/toggle-switch.component';

@NgModule({
  imports: [
    FormFieldComponent,
    FormTextareaComponent,
    DatepickerComponent,
    TimepickerComponent,
    ToggleSwitchComponent,
    FileUploaderComponent,
  ],
  exports: [
    FormFieldComponent,
    FormTextareaComponent,
    DatepickerComponent,
    TimepickerComponent,
    ToggleSwitchComponent,
    FileUploaderComponent,
  ],
})
export class FormKitModule {}
